<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;"
          >每60秒刷新当前页面
          </el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in financeChecktabs"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs>
          <finance-seach
            :column-option="tapList"
            ref="clearSeachInfo"
            @onSearch="getList"
          >
            <div class="search_rightitem" v-show="activeName === '1'">
              <el-button type="primary"  :disabled="!list.length" @click="MassClaim">批量认领</el-button>
            </div>
          </finance-seach>

          <div class="box-table" :style="{height: financeTableHeight + 'px'}">
            <el-table
              border
              type="reset"
              ref="tableRef"
              :data="list"
              :max-height="financeTableHeight"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column :key="1" type="selection" width="55" :selectable="selectableFun" v-if="activeName === '1'"></el-table-column>
              <el-table-column
                prop="invoiceReceiveNumber"
                label="收票编号"
                :key="2"
              >
                <template slot-scope="scope">
                  <span class="approval" @click="deal(scope.row)">{{scope.row.invoiceReceiveNumber}}</span>
                </template>
              </el-table-column>
              <el-table-column :key="3" prop="invoiceReceiveCompany" label="公司名称"></el-table-column>
              <el-table-column :key="4" prop="invoiceNumber" label="发票编号"></el-table-column>
              <el-table-column :key="5" label="发票金额" prop="amount" width="100">
                <template slot-scope="scope">
                  {{ scope.row.amount | priceFilterNum }}
                </template>
              </el-table-column>
              <el-table-column :key="6" prop="taxAmount" label="税额" width="80"></el-table-column>
              <el-table-column :key="7" prop="invoiceType" label="发票类型" width="100"></el-table-column>
              <el-table-column :key="8" prop="bilingType" label="收票类型" width="100"></el-table-column>
              <el-table-column
                label="收票状态"
                width="120"
                :key="9"
                prop="invoiceState"
                v-if="activeName ==='3'"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceState | invoiceState }}</span>
                </template>
              </el-table-column>
              <el-table-column :key="10" prop="createUser" label="申请人" width="80"></el-table-column>
              <el-table-column :key="11" prop="orgName" label="所属部门"></el-table-column>
              <el-table-column
                prop="createDate"
                label="申请时间"
                width="140"
                :key="12"
                v-if="activeName === '1' || activeName === '2'"
              >
                <template slot-scope="scope">{{ scope.row.createDate | dateFilter }}</template>
              </el-table-column>
              <el-table-column :key="13" prop="invoiceReceiveDate" label="申请收票时间" v-if="activeName ==='3'">
                <template slot-scope="scope">{{ scope.row.createDate | dateFilter }}</template>
              </el-table-column>
              <el-table-column :key="14" prop="invoiceReceiveDate" label="收票时间" v-if="activeName ==='3'">
                <template slot-scope="scope">{{ scope.row.invoiceReceiveDate | dateFilter }}</template>
              </el-table-column>
              <el-table-column
                prop="processUser"
                label="认领人"
                :key="15"
                v-if="activeName === '1'"
              >
                <template v-slot="{row}">{{row.processUser||'--'}}</template>
              </el-table-column>
              <el-table-column :key="16" prop="processDate" label="认领时间" v-if="activeName === '1' || activeName === '2'">
                <template slot-scope="scope">{{ scope.row.processDate | dateFilter }}</template>
              </el-table-column>
              <el-table-column :key="17" prop="processUser" label="处理人" v-if="activeName==='3'"></el-table-column>
              <!-- receivePeople -->
              <el-table-column :key="18" fixed="right" label="操作" v-if="activeName==='1'" prop="state">
                <template slot-scope="scope">
                  <el-button type="text" @click="onClaim(scope.row)" v-if="scope.row.extract === 1">认领</el-button>
                  <el-button type="text" @click="onClaim(scope.row)" v-if="scope.row.extract === 2">处理</el-button>
                  <el-button type="text" @click="onClaim(scope.row)" v-if="scope.row.extract === 3">提取</el-button>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :key="19" label="操作" v-else-if="activeName ==='2' || activeName === '3'">
                <template slot-scope="scope">
                  <el-button v-if="activeName ==='2'" type="text" prop="state" @click="onClaim(scope.row)">处理</el-button>
                  <el-button v-if="activeName === '3'" type="text" prop="state" @click="handleExport(scope.row)">导出</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
    </div>
    <!-- 弹框 -->
    <el-dialog title="调整金额" :visible.sync="dialogVisible" width="400px">
      <span style="padding:0 30px;">确定认领收票申请？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureBtn()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 批量认领弹框 -->
    <el-dialog title="认领确认" :visible.sync="dialogVisiblesure" width="400px">
      <div style="padding:0 30px 10px 30px;">
        总开票数：

        <span style="color:#D35E5E;">{{money.list.length}}</span>
        条; 发票总金额：<span style="color:#D35E5E;">{{money.count | count}}</span>
      </div>
      <span style="padding:0 30px;">确定认领开票申请？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="misssurn">确 定</el-button>
        <el-button @click="dialogVisiblesure = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import {
  financeChecktabs,
  financeCheckList,
  findTapTwo,
  findTapThere
} from '../financeManage/util/data'

import { downLoadFileBlob } from '@/util/tool'
import { updateStateByPciId, queryByFinance, financeReceiptExport } from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
import { mapState } from 'vuex'

export default {
  components: {
    pagination: pagination,
    financeSeach
  },

  data () {
    return {

      isSelctItem: {},
      money: {
        list: [],
        count: 0
      },
      row: {},
      processState: '',
      type: '',
      activeName: '', // tabs选中状态
      financeChecktabs: financeChecktabs, // tabs状态
      loadingTable: false, // 列表loading
      loadingTables: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {},
      financeCheckList: financeCheckList, // 筛选条件
      expressionList: expressionList,
      findTapTwo: findTapTwo,
      findTapThere: findTapThere,
      checked: false,
      dialogVisible: false,
      dialogVisiblesure: false,
      state: '',
      id: 0,
      multipleSelection: [],
      tapList: [],
      value: '',
      isShow: false,
      preParams: '',
      exportLoading: false
    }
  },
  mounted () {
    this.activeName = '1'
    this.tapList = this.financeCheckList
    this.getList()
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  watch: {
    checked (newVal) {
      clearInterval(this.timer)
      if (newVal) {
        this.timer = setInterval(() => {
          this.getList()
        }, 60000)
      }
      return newVal
    },
    activeName (newVal) {
      switch (newVal) {
        case '1':
          this.tapList = [...financeCheckList,
            {
              label: '申请时间',
              value: 'createDate'
            },
            {
              label: '认领人',
              value: 'recevieUser'
            },
            {
              label: '认领时间',
              value: 'processDate'
            }]
          break
        case '2':
          this.tapList = [...financeCheckList,
            {
              label: '申请时间',
              value: 'createDate'
            },
            {
              label: '认领时间',
              value: 'processDate'
            }]
          break
        case '3':
          this.tapList = [...financeCheckList,
            {
              label: '申请收票时间',
              value: 'createDate'
            },
            {
              label: '收票状态',
              value: 'invoiceState'
            },
            {
              label: '收票时间',
              value: 'invoiceReceiveDate'
            }]
          break
      }
      return newVal
    }
  },
  filters: {
    count (count) {
      if (!count || count === 0) {
        return '0.00'
      }
      return count.toFixed(2)
    },
    invoiceState (invoiceState) {
      if (invoiceState === 1) {
        return '未收票'
      } else if (invoiceState === 2 || invoiceState === 3) {
        return '已收票'
      } else if (invoiceState === 4) {
        return '审核不通过'
      } else if (invoiceState === 5) {
        return '已收票'
      }
    }
  },
  methods: {
    selectableFun (row) {
      return row.state === 1
    },
    changeEvent () {
      if (this.queryParams.column === 'createDate' ||
          this.queryParams.column === 'processDate' ||
          this.queryParams.column === 'invoiceReceiveDate') {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 重置
    searchReset () {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 搜索
    searchFor () {
      this.getList()
    },

    // 处理
    deal (row) {
      this.$router.push({
        name: 'TicketCollection',
        query: {
          invoiceReceiveNumber: row.invoiceReceiveNumber,
          type: '3',
          id: row.id
        }
      })
    },
    // 处理
    draw (row) {},
    // 批量领取
    MassClaim () {
      var sum = 0
      if (this.multipleSelection.length !== 0) {
        this.money.list = this.multipleSelection
        let isflag = false
        this.money.list.forEach((v2, i2) => {
          if (Number(v2.state) === 2) {
            isflag = true
          }
          if (v2.amount !== null) {
            sum += v2.amount
          }
        })

        this.money.count = sum
        this.dialogVisiblesure = true
        // if (isflag === true) {
        //   this.$message.error('条件必须一致！')
        //   this.dialogVisiblesure = false
        //   return false
        // }
      } else {
        this.$message.error('至少选在一条或多条！')
      }
    },
    misssurn () {
      let list = []
      list = this.multipleSelection.map((item) => {
        return {
          id: item.id,
          megerCode: item.mergeNumber
        }
      })
      updateStateByPciId(list, 2, '', 'updateStateByPciIdClaimAll')
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.loadingTable = false
            this.getList()
          }
        })
        .catch((err) => {
          console.log(err)
        })
      this.dialogVisiblesure = false
    },
    // 认领
    onClaim (row) {
      if (row.extract === 1) {
        this.id = row.id
        this.isSelctItem = row
        this.processState = row.state
        this.sureBtn()
      } else if (row.extract === 2) {
        this.$router.push({
          name: 'TicketCollection',
          query: {
            invoiceReceiveNumber: row.invoiceReceiveNumber,
            type: this.activeName,
            id: row.id
          }
        })
      } else {
        const src =
          this.$route.query.type === '开票退票'
            ? 'purchaseContractInvoiceSub'
            : 'orderContractInvoiceSub'

        const paramsbank = [
          {
            id: row.id,
            type: src
          }
        ]
        updateStateByPciId(paramsbank, 1, '', 'updateStateByPciIdExtract')
          .then((res) => {
            this.$message({
              message: res.data.msg,
              type: res.data.code === 200 ? 'success' : 'error'
            })
            this.loadingTable = false
            this.isSelctItem.state = this.isSelctItem.state = 2
            this.getList()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 确认
    sureBtn () {
      const src =
        this.$route.query.type === '开票退票'
          ? 'purchaseContractInvoiceSub'
          : 'orderContractInvoiceSub'

      const paramsbank = [
        {
          id: this.id,
          type: src
        }
      ]
      updateStateByPciId(paramsbank, 2, '', 'updateStateByPciIdClaim')
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: res.data.code === 200 ? 'success' : 'error'
          })
          this.loadingTable = false
          this.isSelctItem.state = this.isSelctItem.state = 2
          this.getList()
        })
        .catch((err) => {
          console.log(err)
        })
      this.dialogVisible = false
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      this.activeName = tab.name
      if (this.activeName === '1') {
        this.tapList = this.financeCheckList
      } else if (this.activeName === '2') {
        this.tapList = this.findTapTwo
      } else if (this.activeName === '3') {
        this.tapList = this.findTapThere
      }
      this.$refs.clearSeachInfo.innerInit()
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList (list) {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.type = 1
      } else if (this.activeName === '2') {
        this.type = 2
      } else if (this.activeName === '3') {
        this.type = 3
      } else {
        this.type = 1
      }

      const params = {
        criteriaVoList: list || this.preParams || [],
        queryPageName: ''
      }
      if (list) {
        this.currentPage = 1
      }
      // console.log(this.miState)
      queryByFinance(this.type, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.preParams = list || this.preParams || []
            this.list = res.data.obj.records
            this.list.forEach((v, i) => {
              if (v.state === 1) {
                this.$set(v, 'isEnable', true)
              } else {
                this.$set(v, 'isEnable', false)
              }
            })
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }

      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    handleExport(row) {
      if (this.exportLoading) return
      this.exportLoading = true
      const params = {
        invoicePayUrl: '60c1a65367e4437715f3ede3',
        purchaseContractInvocieTeamVo: row
      }
      financeReceiptExport(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
